import React from 'react';
import { Sparkles } from 'lucide-react';
import type { ActiveBonus } from '../../../types/game';

interface BonusPanelProps {
    bonus: ActiveBonus;
}

export const BonusPanel: React.FC<BonusPanelProps> = ({ bonus }) => {
    return (
        <div className="bg-yellow-400/20 backdrop-blur-sm rounded-lg p-3 mb-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <Sparkles className="w-5 h-5 text-yellow-400" />
                <span className="text-yellow-200">Active Bonus</span>
            </div>
            <div className="flex items-center gap-3">
                <span className="text-yellow-200 text-sm">{bonus.multiplier}x</span>
                <span className="bg-yellow-400/30 px-2 py-0.5 rounded text-xs">
                    {bonus.spinsLeft} spins left
                </span>
            </div>
        </div>
    );
}; 